/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable comma-spacing */
/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { ArrowLeftOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Table, Tabs, notification, Tooltip, Typography, Select,Button } from 'antd';
import { useHistory } from 'react-router-dom';
import BlankProject from './BlankProject';
import BlankWbs from './BlankWbs';
import { GetRefreshInfo } from '../../../redux/FinanceMapping/saga';

const { TabPane } = Tabs;
const { Title,Text } = Typography;
const { Option } = Select;

const Checks1Tabs = () => {
    const history = useHistory();
    const [group, setGroup] = useState(false);
    const [currentSection, setCurrentSection] = useState('1');
    const [year, setYear] = useState([])
    const [selectedYear, setSelectedYear] = useState(null);
    const [layoutSave, setLayoutSave] = useState(false);
    const [layoutLoad, setLayoutLoad] = useState(false);
    const [refreshInfo, setRefreshInfo] = useState(null);
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const info = await GetRefreshInfo('Project_Summary_Consol');
                if (info.Date_Time){
                    setRefreshInfo(info.Date_Time)
                }
            } catch (error) {
                console.error("Error fetching info:", error);
            }
        };
    
        fetchInfo();
    }, []);


    const onChange = (key) => {
        setCurrentSection(key);
    };

    return (
        <div className="h-100 d-flex flex-column">
            <div className="d-flex mb-2 tab-content-title" style={{ justifyContent: 'space-between' }}>
                <div className='back_equip' >
                    <Tooltip title={'Back'} >
                        <ArrowLeftOutlined onClick={(e) => {
                            history.push('/project-margin');
                        }} />
                    </Tooltip>
                    <Title className="mb-0 mt-1 add-new-calibration" level={3} style={{ paddingLeft: '30px' }}>
                        Check1
                    </Title>
                </div>
                <div className="new-calibration">
                <Text className="ps-3 add-new-calibration" style={{ marginTop: '10px', marginRight: '20px' }}>Refresh Date: {refreshInfo}</Text>
                    {
                        // userGroup && userGroup.includes('pricing-admin') &&
                        <Button shape="round" key="apply" type="primary" style={{ marginRight: '20px' }}
                            // onClick={showMasterModal}
                            onClick={() => {
                                history.push('/raw-data');
                            }}
                        >
                            Raw Data
                        </Button>

                    }

                    <Button shape="round" key="apply" type="primary" style={{ marginRight: '20px' }} loading= {layoutSave}
                        // onClick={showMasterModal}
                        onClick={() => {
                            setLayoutSave(true)
                           
                        }}
                    >
                       Save Layout
                    </Button>
                    
                    {/* <Button shape="round" key="apply" type="primary" style={{ marginRight: '20px' }} loading= {layoutLoad}
                        // onClick={showMasterModal}
                        onClick={() => {
                            setLayoutLoad(true)
                        }}
                    >
                       Load Layout
                    </Button> */}

                </div>
                <div style={{}}>
                    {/* <Select
                        className="maintenance-select"
                        placeholder="Select Year"
                        onChange={(value) => setSelectedYear(value)}
                        value={selectedYear}
                        size="medium"
                        showSearch
                        allowClear
                        defaultValue={year.length > 0 ? year[0] : undefined}
                        style={{ width: '150px', paddingLeft: '5px', paddingRight: '5px' }}
                    >
                        {year.length > 0 &&
                            year.map((item, i) => (
                                <Option key={i} value={item}>
                                    {item}
                                </Option>
                            ))}
                    </Select> */}

                </div>
            </div>
            <div className="flex-fill">
                <Tabs
                    className="custom-tab h-100"
                    onChange={onChange}
                >
                    <TabPane tab="Blank Projects" key="1">
                    {currentSection == '1' ?
                        <BlankProject selectedYear={selectedYear} setSelectedYear={setSelectedYear} year={year} setYear={setYear} layoutSave = {layoutSave} layoutLoad = {layoutLoad} 
                        setLayoutSave ={setLayoutSave} setLayoutLoad ={setLayoutLoad} />
                         : null
                        }
                    </TabPane>
                    <TabPane tab="Blank WBS" key="2">
                    {currentSection == '2' ?
                        <BlankWbs selectedYear={selectedYear} setSelectedYear={setSelectedYear} year={year} setYear={setYear} layoutSave = {layoutSave} layoutLoad = {layoutLoad} 
                        setLayoutSave ={setLayoutSave} setLayoutLoad ={setLayoutLoad} />
                         : null
                        }
                    </TabPane>
                </Tabs>
            </div>
        </div>
    );
};

export default Checks1Tabs